var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.27a11 11 0 007.52 10.44c.55.1.75-.24.75-.53v-1.87c-3.07.69-3.72-1.48-3.72-1.48a2.92 2.92 0 00-1.22-1.61c-1-.68.08-.66.08-.66a2.28 2.28 0 011.68 1.13 2.33 2.33 0 003.2.91 2.39 2.39 0 01.7-1.47c-2.44-.27-5-1.22-5-5.43a4.29 4.29 0 011.13-3 4 4 0 01.11-2.91s.93-.29 3 1.13A10.92 10.92 0 0112 6.59a10.92 10.92 0 012.75.41c2.1-1.42 3-1.13 3-1.13a4 4 0 01.11 2.91 4.29 4.29 0 011.13 3c0 4.22-2.57 5.15-5 5.42a2.63 2.63 0 01.75 2v3c0 .34.2.64.75.53A11 11 0 101 12.27z"
  })));
}

export default SvgGithub;